import enLang from 'element-ui/lib/locale/lang/en'
const messages = {
  ...enLang,
  "banner1": "Solplanet brand is a development of AISWEI",
  "banner2": "formerly SMA China",
  "banner3": "Solar for Everybody",
  "english": "English",
  "polish": "Polish",
  "spanish": "Spanish",
  "turkish": "Turkish",
  "germany": "German",
  "french": "French",
  "italian": "Italian",
  "systemData1": "System",
  "installationLocation1": "Installation",
  "customerData1": "Customer",
  "claimData": "Claim",
  "shippingAddress1": "Shipping",
  "customerData": "Customer / Client Data",
  "customerType": "Inquirer type",
  "selectCustomer": "Please select inquirer type",
  "--None--": "--None--",
  "Installer": "Installer",
  "End-customer": "End-customer",
  "Distributor": "Distributor",
  "EPC": "EPC",
  "Other": "Other",
  "companyName": "Company Name",
  "typeCompanyName": "Please enter company name",
  "contacts": "Contact name",
  "typeContacts": "Please enter contact name",
  "contactInformation": "Phone Number",
  "typeContactInformation": "Please enter Phone Number",
  "shippingAddress": "Shipping Address(Please note that this address will serve as the shipping address in the case of an exchange.)",
  "country": "Country/Region",
  "typeCountry": "Please enter country/region",
  "province": "State",
  "typeProvince": "Please enter state",
  "city": "City",
  "typeCity": "Please enter city",
  "area": "Street",
  "typeArea": "Please enter the full address (down to the house number)",
  "contacts01": "Mobile phone",
  "typeContacts01": "Please enter mobile phone",
  "postCode": "Postal Code",
  "typePostCode": "Please enter postal code",
  "email": "Email",
  "typeEmail": "Please enter email",
  "errorEmail": "Please enter valid email address.",
  "installationLocation": "Installation Location(use shipping address",
  "purchaseDate": "Purchase Date",
  "typePurchaseDate": "Please enter purchase date",
  "installDate": "Install Date",
  "typeInstallDate": "Please enter install date",
  "faultyDeviceType": "Faulty Device type",
  "selectFaultyDeviceType": "Please select faulty device type",
  "faultDate": "Fault Date",
  "typeFaultDate": "Please enter fault date",
  "deviceSerialNumber": "Device serial number",
  "typeDeviceSerialNumber": "Please enter device serial number",
  "faultySymptom": "Faulty symptom",
  "selectFaultySymptom": "Please select faulty symptom",
  "errorDescription": "Detailed error description",
  "typeErrorDescription": "Please type detailed error description",
  "purchaseFileId": "Purchase voucher (attachment)",
  "purchaseDesc": "The proof of purchase must include customer’s name, installation address, inverter model and the fact that it has been paid",
  "breakFileId": "Failure Certificate (attachment)",
  "breakDesc": "Please submit a photo of the defect detail, the error message and the product serial number sticker",
  "upload": "Upload",
  "systemData": "System Data (optional)",
  "systemData01": "Is it the first claim of this site?",
  "Yes": "Yes",
  "No": "No",
  "Unknown": "Unknown",
  "systemData02": "Other inverters operating status of the same site",
  "systemData03": "Reason for earlier claim",
  "enterSystemData03": "Please enter reason for earlier claim",
  "systemData04": "Fault detail of other inverters on the same site",
  "enterSystemData04": "Please enter fault detail of other inverters on the same site",
  "systemData05": "Inverter installation environmental conditions",
  "systemData0501": "Indoor",
  "systemData0502": "Outdoor(under the shaded site of the building or mount an awning)",
  "systemData0503": "Outdoor(exposing the inverter to direct sunlight)",
  "systemData0504": "Above water",
  "systemData0505": "Others",
  "systemData06": "Solar panels installation environmental conditions",
  "systemData0601": "On the ground",
  "systemData0602": "On the rooftop",
  "systemData0603": "On the water surface",
  "systemData0604": "Others",
  "systemData07": "Solar panel brand&model",
  "typeSystemData07": "Please enter solar panel brand&model",
  "systemData08": "PV mode",
  "systemData0801": "Independent",
  "systemData0802": "Parallel",
  "pleaseSelect": "Please select",
  "add": "Add",
  "delete": "Delete",
  "pv10": "string solar panel(pieces)",
  "pv101": "PV1string solar panel(pieces)",
  "pv102": "PV2string solar panel(pieces)",
  "pv103": "PV3string solar panel(pieces)",
  "pv104": "PV4string solar panel(pieces)",
  "circuit01": "open circuit voltage(V)",
  "alternatingVoltage": "Alternating Voltage",
  "l1l2": "AC voltage L1 - L2(V)",
  "l1n": "AC voltage L1 - N(V)",
  "l2l3": "AC voltage L2 - L3(V)",
  "l2n": "AC voltage L2 - N(V)",
  "l1l3": "AC voltage L1 - L3(V)",
  "l3n": "AC voltage L3 - N(V)",
  "l1pe": "AC voltage L1 - PE(V)",
  "l3pe": "AC voltage L3 - PE(V)",
  "l2pe": "AC voltage L2 - PE(V)",
  "npe": "AC voltage N - PE(V)",
  "complaintFileId": "Attachment",
  "activeTip": "Notice：The more detail installation information you can provide, the quicker we can identify the problem.",
  "submitBtn": "Submit",
  "pleaseType": "Please enter",
  "submitSuccess": "Submit success",
  "submitDesc": "Some required fields are not filled in, please resubmit after confirmation. Thank you!",
  "typeUpload": "Please upload",
  "resetUpload": "Reupload",
  "selectErrorMessage": "Please select error message",
  "errorMessage": "Other",
  "MPPT": "MPPT",
  "chinese": "Chinese",
  "dutch": "Dutch",
  "hungary": "Hungary",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "I agree with Solplanet terms & conditions",
  "iagree": "I agree with Solplanet terms & conditions",
  "language": "Language",
  "ptbr": "Portuguese (Brazil)",
  "zhtw": "Traditional Chinese",
  "documentTitle": "Warranty │Solplanet",
  "validateNumber": "Please enter an integer"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/en.js